import { OpenModal } from 'contexts/ModalContext/ModalContext.type';

export const handlePlanPaused = ({ openModal }: { openModal: OpenModal }) => {
    openModal.planPaused();
};
